import { __decorate } from "tslib";
import { AnyDecoder, ArrayDecoder, AutoEncoder, DateDecoder, EnumDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { BalanceItem, BalanceItemWithPayments } from './BalanceItem.js';
import { PaymentGeneral } from './members/PaymentGeneral.js';
export var ReceivableBalanceType;
(function (ReceivableBalanceType) {
    ReceivableBalanceType["organization"] = "organization";
    ReceivableBalanceType["member"] = "member";
    ReceivableBalanceType["user"] = "user";
    ReceivableBalanceType["registration"] = "registration";
})(ReceivableBalanceType || (ReceivableBalanceType = {}));
export function getReceivableBalanceTypeName(type, $t) {
    switch (type) {
        case ReceivableBalanceType.organization: return $t('b66501e0-f6de-4259-95ef-13590b24182b');
        case ReceivableBalanceType.member: return $t('146d0874-2f4d-4374-8808-61a4bd953354');
        case ReceivableBalanceType.user: return $t('fbb0dee5-c500-4bb4-81d6-945666ae4784');
        case ReceivableBalanceType.registration: return $t('b4a0f9cb-ecd0-4f9b-bd28-9e4a6c8b1518');
    }
}
/**
 * @deprecated
 * @param type
 * @returns
 */
export function getReceivableBalanceTypeNameNotTranslated(type) {
    switch (type) {
        case ReceivableBalanceType.organization: return 'vereniging';
        case ReceivableBalanceType.member: return 'lid';
        case ReceivableBalanceType.user: return 'account';
        case ReceivableBalanceType.registration: return 'inschriving';
    }
}
export class ReceivableBalanceObjectContact extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.firstName = null;
        this.lastName = null;
        this.emails = [];
        /**
         * Meta data that is used for filtering who to email
         */
        this.meta = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], ReceivableBalanceObjectContact.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], ReceivableBalanceObjectContact.prototype, "lastName", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], ReceivableBalanceObjectContact.prototype, "emails", void 0);
__decorate([
    field({ decoder: AnyDecoder, nullable: true, version: 346 })
], ReceivableBalanceObjectContact.prototype, "meta", void 0);
export class ReceivableBalanceObject extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = '';
        this.uri = null;
        // E-mail addresses to reach out to this entity
        this.contacts = [];
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], ReceivableBalanceObject.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], ReceivableBalanceObject.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 362 })
], ReceivableBalanceObject.prototype, "uri", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(ReceivableBalanceObjectContact) })
], ReceivableBalanceObject.prototype, "contacts", void 0);
/**
 * An entity (organization, member or user) that has an outstanding balance towards an organization
 */
export class ReceivableBalance extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.amountPaid = 0;
        this.amountOpen = 0;
        this.amountPending = 0;
        this.lastReminderEmail = null;
        this.lastReminderAmountOpen = 0;
        this.reminderEmailCount = 0;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], ReceivableBalance.prototype, "id", void 0);
__decorate([
    field({ decoder: new EnumDecoder(ReceivableBalanceType) })
], ReceivableBalance.prototype, "objectType", void 0);
__decorate([
    field({ decoder: ReceivableBalanceObject })
], ReceivableBalance.prototype, "object", void 0);
__decorate([
    field({ decoder: StringDecoder })
], ReceivableBalance.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 354 })
], ReceivableBalance.prototype, "amountPaid", void 0);
__decorate([
    field({ decoder: IntegerDecoder, field: 'amount' }),
    field({ decoder: IntegerDecoder, version: 354 })
], ReceivableBalance.prototype, "amountOpen", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], ReceivableBalance.prototype, "amountPending", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true, version: 355 })
], ReceivableBalance.prototype, "lastReminderEmail", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 355 })
], ReceivableBalance.prototype, "lastReminderAmountOpen", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 355 })
], ReceivableBalance.prototype, "reminderEmailCount", void 0);
export class DetailedReceivableBalance extends ReceivableBalance {
    constructor() {
        super(...arguments);
        this.balanceItems = [];
        this.payments = [];
    }
    get filteredBalanceItems() {
        return BalanceItem.filterBalanceItems(this.balanceItems);
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(BalanceItemWithPayments) })
], DetailedReceivableBalance.prototype, "balanceItems", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(PaymentGeneral) })
], DetailedReceivableBalance.prototype, "payments", void 0);
//# sourceMappingURL=ReceivableBalance.js.map